import { InserisciScadenze } from "./inserisci-scadenze";

export class ApplicaScadenzeRequest {
    idFascicolo: string;
    //idSezione: string;
    scadenze: InserisciScadenze[] = [];

}